import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ComponentRoutingModule } from './component-routing.module';
import { HomeComponent } from './home/home.component';
import { SigninComponent } from './signin/signin.component';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { LoginComponent } from './layouts/login/login.component';
import { NotificationToastComponent } from './notification-toast/notification-toast.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FullCalendarModule } from '@fullcalendar/angular';


@NgModule({
  declarations: [
    HomeComponent,
    SigninComponent,
    DashboardComponent,
    LoginComponent,
    NotificationToastComponent
  ],
  imports: [
    CommonModule,
    ComponentRoutingModule,
    ReactiveFormsModule,
    FormsModule,NgxSpinnerModule,
    FullCalendarModule
  ],
  providers: [DatePipe]
})
export class ComponentModule { }
